import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import Layout from '../../../dashboard/components/Layout'
import Card from '../../../../components/Card'
import './index.css'
import TextAreaField from '../../../../components/Form/TextArea'
import { IMG_URL } from '../../../../config'
import { useAppSelector, useAppDispatch } from '../../../../redux/hook'
import { timeOffDetail, whoElseIsOff, approveOrReject } from '../../api'
import { HIDE_LOADER, SHOW_LOADER } from '../../../../redux/slices/LoaderSlice'
import { formatDate } from '../../../resources/empresources/utils'
import { TimeOffRequest, WhoElseIsOffI } from '../../pages/type'
import { SHOW_NOTIFICATION } from '../../../../redux/slices/showNotificationSlice'
import profile from '../../../../assets/images/default-placeholder.png'
import { Button } from 'react-bootstrap'
import { MAX_CHAR_COUNT } from '../../../../utils/index'

const ViewRequest: React.FC = () => {
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const { role } = useAppSelector((state) => state.persistedReducers.user)
    const location = useLocation()

    const [viewRequestedTimeOff, setViewRequestedTimeOff] =
        useState<TimeOffRequest | null>(null)
    const [isChecked, setIsChecked] = useState<boolean>(false)
    const [whoElseIsOffData, setWhoElseIsOffData] = useState<WhoElseIsOffI[]>(
        []
    )
    const [notes, setNotes] = useState<string | null>('')

    const pathSegments = location.pathname.split('/')
    const timeOffRequestId = pathSegments[pathSegments.length - 1]

    useEffect(() => {
        const fetchData = async () => {
            try {
                dispatch(SHOW_LOADER())
                const response = await timeOffDetail(timeOffRequestId)
                const whoElseOff = await whoElseIsOff()
                setWhoElseIsOffData(whoElseOff.data)
                setViewRequestedTimeOff(response.data)
            } catch (error) {
                console.error(error)
            } finally {
                dispatch(HIDE_LOADER())
            }
        }
        fetchData()
    }, [timeOffRequestId])

    const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setIsChecked(e.target.checked)
    }

    const handleApproveRequest = async (isApprove: boolean) => {
        try {
            dispatch(SHOW_LOADER())
            const requestBody = {
                timeOffRequestId: timeOffRequestId,
                isApproved: isApprove,
                notes: notes ? notes : null,
            }
            const response = await approveOrReject(requestBody)
            if (response?.status === 200) {
                dispatch(
                    SHOW_NOTIFICATION({
                        message: `Timeoff ${response?.data} successfully`,
                        type: 'success',
                    })
                )
                navigate(-1)
            }
        } catch (error) {
            console.error(error)
        } finally {
            dispatch(HIDE_LOADER())
        }
    }

    return (
        <div>
            <Layout>
                <div className="row">
                    <div
                        className={
                            role !== 'Teacher' ? 'col-sm-8' : 'col-sm-12'
                        }
                    >
                        <Card>
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <h6>
                                    <p>Time-Off Requests</p>
                                </h6>
                                <div className="col-auto me-2">
                                    <Button
                                        className="button button-primary"
                                        type="button"
                                        onClick={() => navigate(-1)}
                                    >
                                        BACK
                                    </Button>
                                </div>
                            </div>

                            <div className="row user-info mt-5">
                                <div className="col-sm-3">
                                    <label>First Name</label>
                                    <p>{viewRequestedTimeOff?.firstName}</p>
                                </div>
                                <div className="col-sm-3">
                                    <label>Middle Name</label>
                                    <p>
                                        {viewRequestedTimeOff?.middleName
                                            ? viewRequestedTimeOff?.middleName
                                            : '--'}
                                    </p>
                                </div>
                                <div className="col-4">
                                    <label>Last Name</label>
                                    <p>{viewRequestedTimeOff?.lastName}</p>
                                </div>
                            </div>

                            <div className="row user-info">
                                <div className="col-sm-6">
                                    <label>Date</label>
                                    <p>
                                        {formatDate(
                                            viewRequestedTimeOff?.startDate
                                        )}{' '}
                                        -{' '}
                                        {formatDate(
                                            viewRequestedTimeOff?.endDate
                                        )}
                                    </p>
                                </div>
                                <div className="col-sm-5">
                                    <label>Duration</label>
                                    <p>
                                        {viewRequestedTimeOff?.duration}{' '}
                                        calendar days
                                    </p>
                                </div>
                                <div className="col-sm-5">
                                    <label>Status</label>
                                    <p>{viewRequestedTimeOff?.currentStatus}</p>
                                </div>
                            </div>

                            <div className="form-group-checks timeoff-view-details-check">
                                <input
                                    type="checkbox"
                                    id="emp-selection"
                                    name="fav_language"
                                    value="allemp"
                                    checked={isChecked}
                                    onChange={handleCheckboxChange}
                                />

                                <label
                                    className="sb-checkbox__label"
                                    htmlFor="emp-selection"
                                >
                                    Show Details
                                </label>
                            </div>

                            {isChecked && (
                                <div className="row user-info">
                                    <div className="col-sm-10">
                                        {viewRequestedTimeOff?.timeOffHoursDetails?.map(
                                            (detail: any) => {
                                                return (
                                                    <div
                                                        key={`${detail.date}`}
                                                        className="time-logs"
                                                    >
                                                        <h6>
                                                            {formatDate(
                                                                detail.date
                                                            )}
                                                        </h6>
                                                        <div className="log-details">
                                                            <div className="col-7 day">
                                                                <span>
                                                                    {detail.day}
                                                                </span>
                                                            </div>
                                                            <div className="col-4 hours">
                                                                <span>
                                                                    {detail.isEnabled ? (
                                                                        detail.hours !==
                                                                        null ? (
                                                                            `${detail.hours} hours`
                                                                        ) : (
                                                                            '8 hours'
                                                                        )
                                                                    ) : (
                                                                        <div className="view-request-timeoff-reason">
                                                                            <span>
                                                                                {
                                                                                    'Non-work-Day'
                                                                                }
                                                                            </span>
                                                                            <span>
                                                                                Reason:{' '}
                                                                                {
                                                                                    detail.reason
                                                                                }
                                                                            </span>
                                                                        </div>
                                                                    )}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            }
                                        )}
                                    </div>
                                </div>
                            )}

                            <div className="row user-info">
                                <div className="col-sm-3">
                                    <label>Total Cost</label>
                                    <p>{viewRequestedTimeOff?.totalCost}</p>
                                </div>
                                <div className="col-sm-3">
                                    <label>Current Stage</label>
                                    <p>
                                        Stage{' '}
                                        {viewRequestedTimeOff?.currentStage} of{' '}
                                        {viewRequestedTimeOff?.totalStage}
                                    </p>
                                </div>
                                <div className="col-4">
                                    <label>First Stage Approved by</label>
                                    <p>
                                        {viewRequestedTimeOff?.firstStageApprovedBy
                                            ? viewRequestedTimeOff?.firstStageApprovedBy
                                            : '--'}{' '}
                                    </p>
                                </div>
                            </div>

                            <div className="row user-info">
                                <div className="col-sm-4">
                                    <label>Currently Assigned to</label>
                                    <p>
                                        {viewRequestedTimeOff?.currentAssignedTo
                                            ? viewRequestedTimeOff?.currentAssignedTo
                                            : '--'}
                                    </p>
                                </div>
                            </div>

                            <div className="row user-info mt-3">
                                <div className="col-sm-12 note-desc">
                                    <h5>
                                        Note by{' '}
                                        {viewRequestedTimeOff?.firstName}{' '}
                                        {viewRequestedTimeOff?.lastName}{' '}
                                    </h5>
                                    <h6>
                                        {viewRequestedTimeOff?.noteByRequester
                                            ? viewRequestedTimeOff?.noteByRequester
                                            : '--'}
                                    </h6>
                                </div>
                            </div>

                            {role !== 'Teacher' && (
                                <>
                                    <div className="row user-info mt-3">
                                        <div className="col-sm-12">
                                            <TextAreaField
                                                name="notes"
                                                label="Notes"
                                                placeholder="Optional response notes"
                                                value={notes ? notes : ''}
                                                onChange={(e) =>
                                                    setNotes(e.target.value)
                                                }
                                                onBlur={() => console.log('')}
                                                error={'errors.notes'}
                                                touched={false}
                                                defaultValue=""
                                                rows={6}
                                                maxLength={MAX_CHAR_COUNT}
                                            />
                                        </div>
                                    </div>
                                    {role !== 'Teacher' && (
                                        <div className="row mt-4 mb-4">
                                            <div className="col-sm-6 button-block">
                                                <button
                                                    onClick={() =>
                                                        handleApproveRequest(
                                                            true
                                                        )
                                                    }
                                                    className="button button-primary me-5"
                                                >
                                                    Approve
                                                </button>
                                                <button
                                                    onClick={() =>
                                                        handleApproveRequest(
                                                            false
                                                        )
                                                    }
                                                    className="button button-outline"
                                                >
                                                    Reject
                                                </button>
                                            </div>
                                        </div>
                                    )}
                                </>
                            )}
                        </Card>
                    </div>
                    {role !== 'Teacher' && (
                        <div className="col-sm-4 who-else-is-off">
                            <Card custom={true}>
                                <div className="mb-5">
                                    <h6>Who Else is Off?</h6>
                                </div>

                                {whoElseIsOffData.map(
                                    (announcements: any, index: any) => {
                                        return (
                                            <div
                                                className="announcemt-section"
                                                key={index}
                                            >
                                                <div className="d-flex profile-img profile">
                                                    <img
                                                        src={
                                                            announcements.imageUrl
                                                                ? `${IMG_URL}${announcements.imageUrl}`
                                                                : profile
                                                        }
                                                    />
                                                    <div className="user-list">
                                                        <h4>
                                                            {
                                                                announcements.userName
                                                            }
                                                        </h4>
                                                        <h5>
                                                            {formatDate(
                                                                announcements.startDate
                                                            )}{' '}
                                                            -{' '}
                                                            {formatDate(
                                                                announcements.endDate
                                                            )}
                                                        </h5>
                                                        <h6
                                                            className={
                                                                announcements.leaveStatus ===
                                                                'Pending'
                                                                    ? 'status'
                                                                    : announcements.leaveStatus ===
                                                                        'Approved'
                                                                      ? 'app'
                                                                      : 'rej'
                                                            }
                                                        >
                                                            {
                                                                announcements.leaveStatus
                                                            }
                                                        </h6>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    }
                                )}
                            </Card>
                        </div>
                    )}
                </div>
            </Layout>
        </div>
    )
}

export default ViewRequest
